module.exports = __webpack_public_path__ + "img/error.c0f5b4c6.svg";